angular.module('angus.controllers').controller('arSummarySettingsCtrl', [
	'$scope',
	function($scope) {
	}
]);